import { type ReactElement } from 'react';
import { Button } from '@mui/material';

import type { LandingType } from '../../../hooks/usePlusWebsites';
import { UrlEditModal } from '../../../components/UrlEditModal';
import { validateExternalHomepageUrl } from '../../../validation';
import { useSwitchLandingType } from '../hooks/useSwitchLandingType';

interface SwitchLandingTypeButtonProps {
  websiteId: string;
  landingType: LandingType;
  externalHomepageUrl: string | null | undefined;
}

// Toggles the website between the in-app builder home page and an external one. Rendered inside
// the home page card; once the builder has a home page, its row offers the same action from the
// overflow menu instead, so both never appear as separate sections.
export function SwitchLandingTypeButton({
  websiteId,
  landingType,
  externalHomepageUrl,
}: SwitchLandingTypeButtonProps): ReactElement {
  const landing = useSwitchLandingType({ websiteId, landingType, externalHomepageUrl });

  return (
    <>
      <Button
        variant="outlined"
        disabled={landing.isSwitching}
        onClick={landing.start}
        className="vtwo:rounded-lg vtwo:text-featured vtwo:border-featured vtwo:hover:border-featured-hover vtwo:hover:bg-featured/[0.04]"
      >
        {landing.label}
      </Button>

      <UrlEditModal
        open={landing.isUrlModalOpen}
        title="External homepage URL"
        initialValue={landing.externalHomepageUrl}
        isSaving={landing.isSwitching}
        hint="Patients landing on your website will be sent to this URL"
        validate={validateExternalHomepageUrl}
        onClose={landing.closeUrlModal}
        onSave={landing.saveExternalUrl}
      />
    </>
  );
}
